import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Auth.css';
import { API_URL } from './config/apiConfig';
import { useContainerScale } from './hooks/useViewportScale';

function ResendConfirmation() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { t } = useTranslation();

  // Viewport scaling for responsive design
  const { 
    scale: viewportScale, 
    offsetX: viewportOffsetX, 
    offsetY: viewportOffsetY,
    baseWidth: containerBaseWidth,
    baseHeight: containerBaseHeight,
    isMobile: isContainerMobile
  } = useContainerScale();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setError('');

    try {
      const apiUrl = API_URL;
      const response = await fetch(`${apiUrl}/auth/resend-confirmation`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage(data.message || t('resendConfirmation.success'));
      } else {
        setError(data.error || t('resendConfirmation.error'));
      }
    } catch (err) {
      setError(t('resendConfirmation.error'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-viewport-wrapper">
      <div className="auth-fullscreen-background" />
      <div 
        className="auth-viewport-container"
        style={{
          width: `${containerBaseWidth}px`,
          height: `${containerBaseHeight}px`,
          transformOrigin: '0 0',
          transform: `translate(${viewportOffsetX}px, ${viewportOffsetY}px) scale(${viewportScale})`,
        }}
      >
        <div className={`auth-container ${isContainerMobile ? 'auth-mobile' : ''}`}>
          <div className="auth-card">
            <div className="auth-game-title">{t('welcome.gameTitle')}</div>
            <p className="auth-subtitle" style={{ marginTop: 20, marginBottom: 30 }}>{t('resendConfirmation.description')}</p>
            
            <form className="auth-form" onSubmit={handleSubmit}>
              <div className="auth-input-group">
                <input
                  type="email"
                  className="auth-input"
                  placeholder={t('resendConfirmation.emailPlaceholder')}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>

              {message && (
                <div className="auth-success">{message}</div>
              )}

              {error && (
                <div className="auth-error">{error}</div>
              )}

              <button 
                type="submit" 
                className="auth-button"
                disabled={loading}
              >
                {loading ? t('resendConfirmation.loading') : t('resendConfirmation.submit')}
              </button>
            </form>

            <div className="auth-links">
              <Link to="/" className="auth-link">{t('resendConfirmation.backToLogin')}</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ResendConfirmation;
